
import { Component } from '@theme/component';

class YearFilter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.buttons = [...this.querySelectorAll('[data-year-filter]')];
    this.items = [...this.querySelectorAll('[data-year-item]')];
    if (!this.buttons.length || !this.items.length) return;

    this.track = this.querySelector('[data-slider-track]');
    this.buttons.forEach((b) => b.addEventListener('click', () => this.apply(b.dataset.yearFilter)));
  }

  apply(year) {
    const attivo = year === this.year ? null : year;
    this.year = attivo;

    this.buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.yearFilter === attivo));
    this.items.forEach((el) => {
      el.hidden = attivo !== null && el.dataset.yearItem !== attivo;
    });

    if (this.track) {
      this.track.scrollTo({ left: 0 });
      this.track.dispatchEvent(new Event('scroll'));
    }
  }
}

if (!customElements.get('year-filter-component')) customElements.define('year-filter-component', YearFilter);
